<template>
<select v-model="index">
  <option :key="idx" v-for="(item, idx) in options" :value="idx">
    {{ item.name }}
  </option>
</select>
</template>

<script>
export default {
  name: "SelectZipcode",
  props: ["value", "options"],
  computed: {
    index: {
      get() {
        return this.value;
      },
      set(val) {
        // input不能改
        this.$emit("input", val);
      },
    },
  },
};
</script>
<style>
select {
 width: 140px;
 padding: 5px 35px 5px 5px;
 font-size: 16px;
 border: 1px solid #000;
 height: 34px;
 -webkit-appearance: none;
 -moz-appearance: none;
 appearance: none;
 background: url("../assets/arrow.png") 96% / 15% no-repeat #fff;
}

/*清除ie的預設選擇框樣式清除，隱藏下拉箭頭*/
select::-ms-expand {
  display: none;
}
</style>
